export const getPermissions = () => {
  try { return JSON.parse(localStorage.getItem("permissions") || "[]"); } catch (_) { return []; }
};

export const can = (permission) => {
  if (!permission) return true;
  const token = localStorage.getItem("access_token");
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    if (["admin", "dev"].includes(String(payload.role || "").toLowerCase())) return true;
  } catch (_) { return false; }
  return getPermissions().includes(permission);
};
